import { Line } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { Box } from "@react-three/flex";
import { useRef } from "react";
import GeoFlex from "../Flexes/GeoFlex";
import ImgFlex from "../Flexes/ImgFlex";

function HeadshotBox({ 
  align, 
  scale, 
  handleThreshold, 
  viewport,
  txtOne,
  txtTwo
}) {

  const groupRef = useRef();

  useFrame(({clock}) => {
    const t = clock.getElapsedTime() / 3
    groupRef.current.rotation.y = t
  });

  return(
    <>
    <Box
      flexDirection='row' 
      align={align} 
      justify='space-evenly'
      width='100%'
      // height='60%'
      margin={scale}
      flexGrow={scale}
      marginBottom={3 * scale}
      marginTop={scale}
    >
      <Box
        marginLeft={scale}
      >
        <ImgFlex
          scale={scale}          
          onReflow={handleThreshold}
          align='center'
          justify='center'
          image='/pictures/headshot_v2.JPG'
          viewport={viewport}
          txtOne={'Developer'}
          txtTwo={'\nDesigner\nMusician'}
          txtColorOne='#7E0000'
          txtColorTwo='#161A1D'
          textScaleFactor={1.025 * scale}
          textAlign='left'
          headshot
        />
      </Box>
      <Box
        dir='column'
        marginLeft={2 * scale}
        marginBottom={2 * scale}
      >
        <group
          ref={groupRef}
        >
          <GeoFlex
            scale={scale}
            onReflow={handleThreshold}
            align='center'
            color='aqua'
            cone
          />
          <GeoFlex
            scale={scale}
            onReflow={handleThreshold}
            align='red'
            color='red'
            sphere
            // rotate        
          />
          <GeoFlex
            scale={scale}
            onReflow={handleThreshold}
            align='center'
            color='aqua'
            invert
            cone
            // spin  
          />
        </group>
      </Box>
    </Box>    
    </>
  );
};

export default HeadshotBox;